import styled from 'styled-components'

export const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)}px;
  table:last-child {
    margin-top: ${({ theme }) => theme.spacing(4)}px;
  }
`
